import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { BarChart3 } from 'lucide-react';

export interface ReportingEmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
}

export const ReportingEmptyState: React.FC<ReportingEmptyStateProps> = ({
  title,
  description,
  icon,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      px: 3,
      py: 6,
      textAlign: 'center',
    }}
  >
    <Box sx={{ mb: 1.5, color: 'text.secondary', opacity: 0.6 }}>
      {icon ?? <BarChart3 size={40} />}
    </Box>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary' }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ mt: 0.5, maxWidth: 360, color: 'text.secondary', fontSize: '0.8rem' }}>
        {description}
      </Typography>
    )}
  </Box>
);
